module.exports = __webpack_public_path__ + "img/sporting-lisbon.bc752888.png";